import './Body.css'
import Cards_Against_Humanity from './images/CAH/1.jpg'
import Betrayal_At_House from './images/Betrayal/1.jpg'
import Escape_The_Dark_Castle from './images/EscapeCastle/1.jpg'
import Exploding_Kittens from './images/ExplodingKittens/1.png'
import Munckin_Deluxe from './images/Munckin/1.jpg'
import Red_Dragon_Inn from './images/RedDragonInn/1.png'
import Catan from './images/Catan/1.jpg'
import Sushi_Go from './images/SushiGo/1.jpg'
import Hanabi from './images/Hanabi/1.jpg'


function Pictures(props) {

  let source;

  switch (props.game) {
    case 'Betrayal_At_House':
      source = Betrayal_At_House;
      console.log(source);
      break;

    case 'Cards_Against_Humanity':
      source = Cards_Against_Humanity;
      console.log(source);
      break;


    case 'Catan':
      source = Catan;
      console.log(source);
      break;

    case 'Escape_The_Dark_Castle':
      source = Escape_The_Dark_Castle;
      console.log(source);
      break;

      case 'Exploding_Kittens':
        source = Exploding_Kittens;
        console.log(source);
        break;
  

    case 'Munchkin_Deluxe':
      source = Munckin_Deluxe;
      console.log(source);
      break;

    case 'Red_Dragon_Inn':
      source = Red_Dragon_Inn;
      console.log(source);
      break;

    case 'Sushi_Go':
      source = Sushi_Go;
      console.log(source);
      break;
      
    case 'Hanabi':
      source = Hanabi;
      console.log(source);
      break;

  }
  return (
    <div>
      <div class="">
        <img
          className="carouselSize w-100"
          src={source}
          alt="First slide"
        />
      </div>
    </div>

  );
}

export default Pictures;
